export const version: string = '0.4.0';
